import { Controller } from "remult";

@Controller("golden-notification-methods")
export class GoldenNotificationMethods {}
